import { modalMapper } from ".";
import { Suspense } from "react";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { modalActions } from "redux/slices/modal";
import CircleLoader from "components/atoms/CircleLoader";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { useTranslation } from "react-i18next";

function AppModal() {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const type = useAppSelector((state) => state.modal.type);
  const open = useAppSelector((state) => state.modal.open);
  const width = useAppSelector((state) => state.modal.width);
  const loading = useAppSelector((state) => state.modal.loading);

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") dispatch(modalActions.closeModal());
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        className="app-modal-body"
        sx={{
          p: 3,
          width: "100%",
          border: "none",
          maxWidth: width,
          maxHeight: "90vh",
          //   overflowY: "auto",
          borderRadius: "16px",
          bgcolor: "background.paper",
          ":focus-visible": {
            outline: "none",
          },
        }}
      >
        <ErrorBoundary>
          <div style={{ minHeight: "123px", position: "relative" }}>
            <CloseIcon
              style={{
                position: "absolute",
                top: "0",
                left: i18n?.language === "ar" ? "0" : "auto",
                right: i18n?.language === "ar" ? "auto" : "0",
                cursor: "pointer",
              }}
              onClick={() => dispatch(modalActions.closeModal())}
            />
            {loading && <CircleLoader />}

            <Suspense fallback={<CircleLoader />}>
              {type && modalMapper[type]}
            </Suspense>
          </div>
        </ErrorBoundary>
      </Box>
    </Modal>
  );
}

export default AppModal;
